// export { default, paginate } from './ItemActions';
import ItemActions, {
  paginate as test,
} from './ItemActions';

export const paginate = test;

export default ItemActions;
